var Curriculog = Curriculog || {};

Curriculog.PageFilter = (function ($, _, Backbone, PageFilter) {
	
	PageFilter = Backbone.View.extend({

		el: function() {
			return $('#curriculog-list-column-results-paging');
		},

		events: {
			'click a': 'execute',
		},

		initialize: function(options) {
			this.params = options.params;
			this.collection = options.collection;
			this.model = options.model;

			if(! _.isEmpty(this.collection.proposals())) {
				this.render();
			}
		},

		render: function() {
			var html = nunjucks.render('ProposalList/proposalListPaging.html',
				{
					paging: this.model.attributes,
					limit: this.params.pagingParams.get('limit'),
					page: this.params.pagingParams.get('page')
				}
			);
			this.$el.append(html);
			this.setElement($('#curriculog-list-column-results-paging'));
		},

		execute: function(event) {
			event.preventDefault();
			var currentPage = this.params.pagingParams.get('page');
			var $currentTarget = $(event.currentTarget);
			var page = $currentTarget.attr('class').match(/paging-(.*)/)[1];
			var pageDirection = (_.contains(['next', 'previous'], page)) ? (page === 'previous') ? -1 : 1 : 0;

			if (pageDirection !== 0) {
				this.params.pagingParams.set('page', parseInt(currentPage, 10) + parseInt(pageDirection, 10));
			} else {
				this.params.pagingParams.set('page', parseInt(page, 10));
			}

			// Broadcast get event
			Backbone.trigger('filter:page');
		},

		reset: function() {
			this.$el.contents().remove();
			this.undelegateEvents();
		},

	});

	return PageFilter;

})($, _, Backbone, Curriculog.PageFilter || {});